/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AddressInput } from './types';

/**
 * These values are used across the Address component. We don't support anything
 * outside of the US for now, so placing these here for now so we
 * have a central place to access them. This can be updated once we have a better idea of how
 * we'll handle non-US customers in the future.
 */
export const locale: AddressInput.Locale = 'en_US';
export const supportUSAndCanadaAddressInputs = false;
